import React from "react";
import { string } from "prop-types";

const GalleryBlackIcon = ({ largeIcon }) =>
  largeIcon ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90">
      <defs>
        <filter id="a" width="90" height="90" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood floodOpacity=".322" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="gallery icon 72px-dark">
        <g filter="url(#a)">
          <circle
            cx="36"
            cy="36"
            r="36"
            data-name="Ellipse 68"
            transform="translate(9 6)"
            fill="#121212"
            opacity=".8"
          />
        </g>
        <path
          d="M58.333 52.667v1.11A3.332 3.332 0 0155 57.11H28.333A3.332 3.332 0 0125 53.777V36a3.332 3.332 0 013.333-3.333h1.112V47.11A5.562 5.562 0 0035 52.667zM65 47.11V29.333A3.332 3.332 0 0061.667 26H35a3.332 3.332 0 00-3.333 3.333V47.11A3.332 3.332 0 0035 50.443h26.667A3.332 3.332 0 0065 47.11zM42.778 32.667a3.333 3.333 0 11-3.333-3.334 3.335 3.335 0 013.333 3.334zm-6.667 10l3.855-3.855a.831.831 0 011.178 0l2.743 2.743 9.412-9.41a.831.831 0 011.178 0l6.077 6.077V46H36.112z"
          data-name="Path 498"
          fill="#e2e2e2"
        />
      </g>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60">
      <defs>
        <filter id="a" width="60" height="60" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood floodOpacity=".322" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="gallery icon 42px-dark">
        <g filter="url(#a)">
          <circle
            cx="21"
            cy="21"
            r="21"
            data-name="Ellipse 127"
            transform="translate(9 6)"
            fill="#121212"
            opacity=".8"
          />
        </g>
        <path
          d="M38 34v.666a2 2 0 01-2 2H20a2 2 0 01-2-2V24a2 2 0 012-2h.667v2h-.417a.25.25 0 00-.25.25v10.166a.25.25 0 00.25.25h15.5a.25.25 0 00.25-.25V34zm1.75-14h-15.5a.25.25 0 00-.25.25v10.166a.25.25 0 00.25.25h15.5a.25.25 0 00.25-.25V20.25a.25.25 0 00-.25-.25zm.25-2a2 2 0 012 2v10.666a2 2 0 01-2 2H24a2 2 0 01-2-2V20a2 2 0 012-2zm-11 4.666A1.667 1.667 0 1127.333 21 1.667 1.667 0 0129 22.666zm-3 4l1.646-1.646a.5.5 0 01.708 0L30 26.666l4.313-4.313a.5.5 0 01.707 0l2.98 2.98v3.333H26z"
          data-name="Path 501"
          fill="#e2e2e2"
        />
      </g>
    </svg>
  );

GalleryBlackIcon.propTypes = {
  largeIcon: string
};

export default GalleryBlackIcon;
